var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FlexColumn',[_c('Label',{attrs:{"bold":"","text":"経験のある職種"}}),_c('PositionsLabel',{attrs:{"positions":this.applicant.currentPositions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }